/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { LoggerService } from '../../shared/services/logger.service';
import { DataFormContentComponent } from './data-form-content.component';
import { DataFormDialogData } from '../state/data-form.model';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'dash-gis-data-form-dialog',
    templateUrl: './data-form-dialog.component.html',
    styleUrls: ['./data-form-dialog.component.scss'],
    imports: [CdkScrollable, MatDialogContent, DataFormContentComponent, MatDialogActions, MatButton],
})
export class DataFormDialogComponent {
    displayName: string;
    formValidity: boolean;

    @ViewChild(DataFormContentComponent) formContent: DataFormContentComponent;

    constructor(
        public logger: LoggerService,
        public dialogRef: MatDialogRef<DataFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public formData: DataFormDialogData
    ) {}

    saveData() {
        this.formContent.saveData();
    }

    setDisplayName(name: string) {
        this.displayName = name;
    }

    isFormValid(valid: boolean) {
        this.formValidity = valid;
    }

    shouldClose(returnValue: any) {
        this.dialogRef.close(returnValue);
    }

    cancel() {
        this.dialogRef.close(false);
    }
}
